import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'

const BudgetFundRequestModalUI = ({ context, messageList, successMsg, errorList, setErrorList,
  // modes
  allocateMode, submitted,
  // event handlers
  onSubmit, onCancelClick
}) =>
  <ModalFormUI
    context={context}
    messageList={messageList}
    titleMessageKey='c_allocate'
    buttonMessageKey='c_allocate'
    cancelMessageKey='c_cancel'
    isOpen={allocateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
  </ModalFormUI>

export default BudgetFundRequestModalUI
